import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  constructor(private messageService: MessageService) {}

  showComingSoon() {
    this.messageService.add({
      severity: 'info',
      summary: 'Noticias',
      detail: 'Estara disponible muy pronto.'
    });
  }
}
